// Weekly statistics: totalen, delta, beste dag, grootste taak.
import { useMemo } from 'react';
import { formatHours } from '@/components/ui/formatHours';

export const useWeeklyStats = (completedDays) => {
  return useMemo(() => {
    if (!completedDays || completedDays.length === 0) {
      return {
        totalHours: 0,
        totalTasks: 0,
        activeDays: 0,
        delta: null,
        bestDay: '',
        biggestTask: null,
      };
    }

    let totalTasks = 0;
    const dayHourMap = {};
    let biggestTask = null;
    let biggestTaskDuration = 0;

    completedDays.forEach((day) => {
      let dayHours = 0;
      day.tasks.forEach((task) => {
        totalTasks++;
        const minutes = getTaskDurationMinutes(task);
        dayHours += minutes / 60;

        if (minutes > biggestTaskDuration) {
          biggestTaskDuration = minutes;
          biggestTask = {
            title: task.title,
            meta: formatHours(minutes / 60),
          };
        }
      });
      dayHourMap[day.label] = dayHours;
    });

    const totalHours = Object.values(dayHourMap).reduce((sum, h) => sum + h, 0);
    const activeDays = Object.keys(dayHourMap).length;

    // Beste dag = dag met meeste uren
    let bestDay = '';
    let bestDayHours = 0;
    Object.entries(dayHourMap).forEach(([label, hrs]) => {
      if (hrs > bestDayHours) {
        bestDayHours = hrs;
        bestDay = label;
      }
    });

    const delta = null;

    return {
      totalHours: Math.round(totalHours * 100) / 100,
      totalTasks,
      activeDays,
      delta,
      bestDay,
      biggestTask,
    };
  }, [completedDays]);
};

/** Lees duur in minuten uit task.duration, met fallback naar meta-string. */
const getTaskDurationMinutes = (task) => {
  if (
    task?.duration !== null &&
    task?.duration !== undefined &&
    task.duration > 0
  )
    return task.duration;
  return parseMetaToMinutes(task?.meta);
};

/** Parseer "Xh Ym", legacy "Xu Ym", of "Xm" terug naar minuten. */
const parseMetaToMinutes = (meta) => {
  if (!meta) return 0;
  let total = 0;
  const hMatch = meta.match(/(\d+)\s*h/);
  if (hMatch) total += parseInt(hMatch[1], 10) * 60;
  const uMatch = meta.match(/(\d+)\s*u/);
  if (uMatch) total += parseInt(uMatch[1], 10) * 60;
  const mMatch = meta.match(/(\d+)\s*m/);
  if (mMatch) total += parseInt(mMatch[1], 10);
  return total;
};
